<script setup>
import { VideoStore } from '@/front/stores/video_store.js'
import InputText from 'primevue/inputtext';
const videoStore = VideoStore();
import { useI18n } from 'vue-i18n'
const { t } = useI18n({});
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import { useRoute } from 'vue-router';
const route = useRoute();
const toast = useToast();
const password = ref('');
const email = ref('');
const code = ref('');
const disabled = ref(false);
import { PlaybackStore } from '@/front/stores/playback_store.js'
const playbackStore = PlaybackStore();
import { usePlaybackInitializer } from '@/front/composables/usePlaybackInitializer.js';
import { AlertCircleIcon, FileNotFoundIcon, Sad01Icon } from 'hugeicons-vue';

const { initialize } = usePlaybackInitializer();

const checkPassword = () => {
  disabled.value = true;
  videoStore.checkPassword(password.value).then((valid) => {
    log.info(1,valid)
    log.info(1,"🔴 Password valid", valid);
    if (valid) {
      videoStore.show(videoStore.video.id, { manage: false, password: password.value }).then(() => {
        initialize(route)
      })
    } else {
      log.info(1,"🔴 Password incorrect");
      toast.add({
        severity: 'error',
        detail: t('common.password_incorrect'),
        life: 5000
      });
    }
  }).catch((error) => {
    log.info(1,"🔴 Password incorrect", error);
    toast.add({
        severity: 'error',
        detail: t('common.password_incorrect'),
        life: 5000
      });
  }).finally(() => {
    password.value = '';
    setTimeout(() => {
      disabled.value = false;
    }, 5000);
  })
}

const checkCode = () => {
  disabled.value = true;
  videoStore.checkCode(email.value, code.value).then((data) => {
    log.info(1,data)
    log.info(1,"🔴 Code valid", data.item_id);
    if (data.item_id) {
      videoStore.show(videoStore.video.id, { manage: false, item_id: data.item_id }).then(async () => {
        playbackStore.viewer.email = email.value;
        playbackStore.viewer.name = data.name || playbackStore.viewer.name || email.value;
        playbackStore.setVariable('email', email.value);
        playbackStore.setVariable('name', playbackStore.viewer.name);
        playbackStore.setVariable('item_id', data.item_id);
        await initialize(route);
      })
    } else {
      toast.add({
        severity: 'error',
        detail: t('common.invalid_credentials'),
        life: 5000
      });
    }
  }).catch((error) => {
    log.info(1,"🔴 Password incorrect", error);
  }).finally(() => {
    setTimeout(() => {
      disabled.value = false;
    }, 5000);
  })
}

</script>

<template>
  <div class="h-full w-full flex flex-col items-center justify-center bg-black text-center text-white">

    
    <!-- LATER make these show in the right order -->
    <div v-if="!videoStore.video.id || videoStore.video.accessible?.not_found" class="flex flex-col items-center justify-center">
      <a href="https://mindstamp.com"> 
      <img 
        class="h-8 mb-4 mx-auto" 
          src="https://resource-cdn.mindstamp.com/assets/images/shake.gif" 
            v-tooltip="'Mindstamp: The Interactive Video Platform ⚡️'"
          >
      <div class="text-base md:text-3xl font-bold mb-4 flex items-center justify-center"> {{ $t('common.video_not_found') }} </div>
      <div class="text-xs md:text-sm mb-4 font-mono text-center opacity-30 "> <router-link to="/">{{ route.params.id }}</router-link> </div>
    </a>

      <!-- <router-link to="/"> 
        <Button severity="info">{{ t('common.go_home') }}</Button>
      </router-link> -->
    </div>
    <div v-else-if="videoStore.video.accessible.list" class="flex flex-col items-center justify-center">
      <div class="text-2xl font-bold mb-4"> {{ $t('common.authentication_required') }} </div>
      <InputText type="email" v-model="email" :placeholder="$t('common.enter_email')" class="mb-4"  autocomplete="off" autofocus />
      <InputText type="text" v-model="code" :placeholder="$t('common.enter_code')" class="mb-4"  autocomplete="off" autofocus @keyup.enter="checkCode"/>
      <Button @click.stop="checkCode" class="!bg-[var(--user-theme-color)]" :disabled="disabled">{{ t('common.submit') }}</Button>
    </div>
    <div v-else-if="videoStore.video.accessible.password">
      <div class="text-2xl font-bold mb-4"> {{ $t('common.password_required') }} </div>
      <InputText type="password" v-model="password" :placeholder="$t('common.enter_password')" class="mb-4"  autocomplete="off" autofocus @keyup.enter="checkPassword"/>
      <Button @click.stop="checkPassword" class="!bg-[var(--user-theme-color)]" :disabled="disabled">{{ t('common.submit') }}</Button>
    </div>
    <div v-else>
      <a href="https://mindstamp.com" target="_blank"> 
        <img 
          v-if="videoStore.video.accessible.expired"
        class="h-8 mb-4 mx-auto" 
        src="https://resource-cdn.mindstamp.com/assets/images/shake.gif" 
          v-tooltip="'Mindstamp: The Interactive Video Platform ⚡️'"
        >
      </a>

      <div class="text-base md:text-xl lg:text-2xl font-bold mb-4"> {{ videoStore.video.title }} </div>
      <div class="text-sm md:text-base lg:text-lg"> {{ $t('common.video_not_available') }}:
        <span v-if="videoStore.video.accessible.expired"> {{ $t('common.expired') }} </span>
        <span v-else-if="videoStore.video.accessible.unpublished"> {{ $t('common.not_published') }} </span>
        <span v-else-if="videoStore.video.accessible.whitelist"> Code 617 </span>
        <span v-else-if="videoStore.video.accessible.embed"> {{ $t('common.embed_only') }} </span>
        <span v-else-if="videoStore.video.accessible.paused"> {{ $t('common.paused') }} </span>
        <span v-else> {{ $t('common.blocked') }} </span>
      </div>
      <div class="text-xs mt-4">{{ videoStore.video.token }} </div>
    </div>
  </div>
</template>
